import { render, staticRenderFns } from "./MergeUser.vue?vue&type=template&id=ba6930de&lang=pug"
import script from "./MergeUser.vue?vue&type=script&lang=js"
export * from "./MergeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports